export default "__VITE_ASSET__92R7qXos__"